import React, { useEffect, useState } from 'react';
const STORAGE_KEY = 'kunst-startklar-launch-deadline';
const DAY_IN_MS = 24 * 60 * 60 * 1000;
interface TimeLeft {
  hours: number;
  minutes: number;
  seconds: number;
}
export function AnnouncementBar() {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    hours: 24,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const storedDeadline = Number(window.localStorage.getItem(STORAGE_KEY));
    let deadline = Number.isFinite(storedDeadline) && storedDeadline > Date.now() ? storedDeadline : Date.now() + DAY_IN_MS;
    window.localStorage.setItem(STORAGE_KEY, String(deadline));
    const updateTimer = () => {
      const now = Date.now();
      if (deadline <= now) {
        deadline = now + DAY_IN_MS;
        window.localStorage.setItem(STORAGE_KEY, String(deadline));
      }
      const totalSeconds = Math.max(0, Math.ceil((deadline - now) / 1000));
      setTimeLeft({
        hours: Math.floor(totalSeconds / 3600),
        minutes: Math.floor(totalSeconds % 3600 / 60),
        seconds: totalSeconds % 60
      });
    };
    updateTimer();
    const interval = window.setInterval(updateTimer, 1000);
    return () => window.clearInterval(interval);
  }, []);
  return <aside className="sticky top-0 z-50 flex h-9 w-full items-center justify-center bg-brand-navy px-2 text-white shadow-sm" data-id="element-18" data-mp="3shb1dzzyko0w">
      <div className="flex items-center gap-2 sm:gap-3" data-id="element-19" data-mp="oyrk1sitj2kv">
        <p className="whitespace-nowrap text-[9px] font-extrabold uppercase tracking-[0.08em] sm:text-[11px]" data-id="element-20" data-mp="oz9qfhz72x6i">
          <span className="text-brand-orange" aria-hidden="true" data-id="element-21" data-mp="tx1f834jm36h">
            ⚡
          </span>{' '}
          Start-Angebot endet in:
        </p>
        <div className="flex items-center gap-1" aria-label={`Noch ${timeLeft.hours} Stunden, ${timeLeft.minutes} Minuten und ${timeLeft.seconds} Sekunden`} data-id="element-22" data-mp="k7hvkv90a5ak">
          <TimerUnit value={timeLeft.hours} label="Std" data-id="element-23" data-mp="1co2dsq1r3wpi" />
          <span className="text-xs font-bold" aria-hidden="true" data-id="element-24" data-mp="1cpn8cfo2ffnd">
            :
          </span>
          <TimerUnit value={timeLeft.minutes} label="Min" data-id="element-25" data-mp="1mjsv1mrgf1q0" />
          <span className="text-xs font-bold" aria-hidden="true" data-id="element-26" data-mp="1hkybujpkrb5d">
            :
          </span>
          <TimerUnit value={timeLeft.seconds} label="Sek" data-id="element-27" data-mp="1clln1tf57u05" />
        </div>
      </div>
    </aside>;
}
function TimerUnit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <span className="whitespace-nowrap text-[11px] font-extrabold tabular-nums sm:text-xs" aria-hidden="true" data-id="element-28" data-mp="13l6se3gah2jz">
      {String(value).padStart(2, '0')}
      <span className="ml-0.5 text-[8px] font-bold uppercase text-white/70" data-id="element-29" data-mp="ysnet6hlq7f6">
        {label}
      </span>
    </span>;
}